module.exports = __webpack_public_path__ + "img/gross.5067186c.png";